module.exports = __webpack_public_path__ + "img/Ru-T600.756ea12f.gif";